import { useTranslation } from 'react-i18next';

import { Markdown } from '../../components/Markdown/Markdown';
import { PageTransition } from '../../components/Transitions/PageTransition';
import { legalText, LEGAL_REVIEW_PENDING, type LegalDoc } from '../../content/legal';
import { useLanguage } from '../../contexts/LanguageContext';

export function LegalPage({ doc }: { doc: LegalDoc }) {
  const { t } = useTranslation();
  const { language } = useLanguage();

  return (
    <PageTransition>
      <article className="max-w-3xl mx-auto px-4 py-10">
        {LEGAL_REVIEW_PENDING && (
          <p
            role="note"
            className="mb-8 rounded-xl border border-status-warning/40 bg-status-warning/10 px-4 py-3 text-sm text-text-secondary"
          >
            {t('legal.draftNotice')}
          </p>
        )}
        <Markdown>{legalText(doc, language)}</Markdown>
      </article>
    </PageTransition>
  );
}
